var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHomephone(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.54 6.08984C7.6 6.97984 7.75 7.84984 7.99 8.67984L6.79 9.87984C6.38 8.67984 6.12 7.40984 6.03 6.08984H7.54ZM17.4 18.1098C18.25 18.3498 19.12 18.4998 20 18.5598V20.0498C18.68 19.9598 17.41 19.6998 16.2 19.2998L17.4 18.1098ZM8.5 4.08984H5C4.45 4.08984 4 4.53984 4 5.08984C4 14.4798 11.61 22.0898 21 22.0898C21.55 22.0898 22 21.6398 22 21.0898V17.5998C22 17.0498 21.55 16.5998 21 16.5998C19.76 16.5998 18.55 16.3998 17.43 16.0298C17.331 15.9929 17.2256 15.9759 17.12 15.9798C16.86 15.9798 16.61 16.0798 16.41 16.2698L14.21 18.4698C11.3755 17.0202 9.06966 14.7144 7.62 11.8798L9.82 9.67984C10.1 9.39984 10.18 9.00984 10.07 8.65984C9.69132 7.50774 9.4989 6.30259 9.5 5.08984C9.5 4.53984 9.05 4.08984 8.5 4.08984Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomephone);
export default __webpack_public_path__ + "static/media/homephone.a0e2c01b9715a66c1ab25208b2fae519.svg";
export { ForwardRef as ReactComponent };